/**
 * Вкладка «Стены» панели «Отделка»: каталог по видам — краска, обои, плитка, штукатурка,
 * панели. Клик по образцу кладёт отделку на выбранные стороны стен и пишет шаг истории.
 * Что выделено (`FinishTargetCard`) — в плашке внизу, на телефоне над каталогом.
 * Полная текстура грузится только в 3D — когда отделка уже на стене.
 */
import { useState } from "react";
import {
	WALL_FINISH_KINDS,
	WALL_FINISH_KIND_LABEL,
	finishItemById,
	type WallFinishKind,
} from "@/shared/catalog";
import { useProjectStore } from "@/shared/store";
import { useWallFinishStore } from "@/shared/store/layers/wallFinishStore";
import { UIKit } from "@/shared/ui";
import { useEditorStore } from "@/widgets/editor";
import { useFinishTarget } from "../hooks/useFinishTarget";
import { finishesOfKind, wallFinishCard } from "../logic";
import { FinishBrowser } from "./FinishBrowser";
import { FinishTargetCard } from "./FinishTargetCard";

export const WallFinishPanel = () => {
	const target = useFinishTarget();
	const isReadOnly = useEditorStore((s) => s.isReadOnly);
	const pushHistory = useProjectStore((s) => s.pushHistory);
	const setFinish = useWallFinishStore((s) => s.setFinish);
	const layerVisible = useWallFinishStore((s) => s.visible);
	const setLayerVisible = useWallFinishStore((s) => s.setVisible);

	const current = target?.currentId ? finishItemById(target.currentId) : null;
	const [kind, setKind] = useState<WallFinishKind>(current?.kind ?? WALL_FINISH_KINDS[0]);

	const tabs = WALL_FINISH_KINDS.map((k) => ({
		key: k,
		label: WALL_FINISH_KIND_LABEL[k],
		cards: finishesOfKind(k).map(wallFinishCard),
	}));

	return (
		<>
			{target ? (
				<div className="max-h-56 shrink-0 overflow-y-auto border-b border-border bg-bg">
					<FinishTargetCard target={target} />
				</div>
			) : (
				<UIKit.Text className="shrink-0 border-b border-border bg-accent-soft px-3 py-2 text-xs text-ink">
					Кликните по стене или полу: появятся их настройки и подходящий каталог.
				</UIKit.Text>
			)}
			{!layerVisible && (
				<UIKit.Text className="shrink-0 border-b border-warning-border bg-warning-soft px-3 py-1.5 text-xs text-warning">
					Слой «Отделка стен» выключен - выбор образца включит его.
				</UIKit.Text>
			)}
			<FinishBrowser
				tabs={tabs}
				tab={kind}
				onTab={setKind}
				activeId={target?.currentId ?? null}
				disabled={target === null || isReadOnly}
				onPick={(card) => {
					if (!target || isReadOnly) return;
					pushHistory();
					setFinish(target.faces, card.id);
					// Выбрали отделку — значит, хотят её видеть
					if (!layerVisible) setLayerVisible(true);
				}}
			/>
		</>
	);
};
